import { useMutation, useQuery } from '@tanstack/react-query';
import { get, put, del } from 'utils/axios';
import {
  MODEL,
  MODELS_SUMMARY_BY_ASSET_MONITORING,
  RELATED_MODELS_SCALING,
  RISK_MODEL_BY_ASSET,
  USER_MODEL,
  USER_MODEL_ON_OFF,
} from 'config/endpoints';
import {
  Model,
  AssetModelsSummary,
  UserModel,
  UserModelPayload,
  AssetScalingModelsSummary,
} from './contract';
import {
  GenericQueryOptions,
  ModelsByAssetProps,
  UserModelDeleteParams,
  UserModelProps,
} from './types';

export const useModelsSummaryByAssetQuery = (
  { assetId }: ModelsByAssetProps,
  options?: GenericQueryOptions<AssetModelsSummary>,
) =>
  useQuery(
    ['MODELS_SUMMARY_BY_ASSET', 'MONITORING_LOADING', assetId],
    get<AssetModelsSummary>(MODELS_SUMMARY_BY_ASSET_MONITORING(assetId)),

    options,
  );
export const useRelatedScalingModels = (
  { modelName }: { modelName?: string },
  options?: GenericQueryOptions<AssetScalingModelsSummary>,
) =>
  useQuery(
    ['RELATED_MODELS_SCALING', 'MODEL_LOADING', modelName],
    get<AssetScalingModelsSummary>(RELATED_MODELS_SCALING(modelName)),

    options,
  );
export const useScalingModelsByAssetQuery = (
  { assetId }: ModelsByAssetProps,
  options?: GenericQueryOptions<AssetScalingModelsSummary>,
) =>
  useQuery(
    ['MODELS_SCALING_BY_ASSET', 'MONITORING_LOADING', assetId],
    get(RISK_MODEL_BY_ASSET(assetId)),

    options,
  );
export const useModelQuery = (
  { assetId, modelName }: UserModelProps,
  options?: GenericQueryOptions<Model>,
) => useQuery(['MODEL', assetId, modelName], get(MODEL(assetId, modelName)), options);

export const useUserModelQuery = (
  { assetId }: UserModelProps,
  options?: GenericQueryOptions<UserModel>,
) => useQuery(['USER_MODEL', assetId], get<UserModel>(USER_MODEL_ON_OFF(assetId)), options);

export const useUserModelMutation = () =>
  useMutation(({ assetId, data }: { assetId?: string | number; data: UserModelPayload }) =>
    put<UserModelPayload, unknown, { model_type: string }>(USER_MODEL_ON_OFF(assetId), {
      payload: data,
    }),
  );

export const useUserModelDeleteMutation = () =>
  useMutation(({ assetId, modelName }: UserModelProps) =>
    del<null, null, UserModelDeleteParams>(USER_MODEL(assetId), {
      params: { model_name: modelName },
    }),
  );
